import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=bb0375a6&scoped=true&"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js&"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewOrder.vue?vue&type=style&index=0&id=bb0375a6&prod&scoped=true&lang=css&"
import style1 from "./CreateNewOrder.vue?vue&type=style&index=1&id=bb0375a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0375a6",
  null
  
)

export default component.exports